export const FormHelpers = {
  toggleButtonState: ({
    isLoading = false,
    buttons = [],
    showSpinner = true,
  }: {
    isLoading: boolean
    buttons: Array<HTMLButtonElement>
    showSpinner?: boolean
  }) => {
    if (isLoading) {
      buttons.forEach((button) => {
        button.disabled = true
        if (showSpinner) button.classList.add('button--loading', 'button--disabled')
      })
      return
    }

    buttons.forEach((button) => {
      button.disabled = false
      if (showSpinner) button.classList.remove('button--loading', 'button--disabled')
    })
  },

  submitForm: async ({
    form,
    buttons = [],
    showSpinner = true,
    onSuccess,
    onError,
  }: {
    form: HTMLFormElement
    buttons: Array<HTMLButtonElement>
    showSpinner?: boolean
    onSuccess: (response: any) => void
    onError: (message: string) => void
  }) => {
    const data = new FormData(form)
    const action = form.getAttribute('action')
    const formMethod = form.getAttribute('method')

    FormHelpers.toggleButtonState({
      isLoading: true,
      buttons,
      showSpinner,
    })

    try {
      const response = await fetch(action, { method: formMethod, body: data })
      const { success, message, ...rest } = await response.json()

      if (!success) {
        onError(message || '')
      } else {
        onSuccess({ message, ...rest })
      }
    } catch (_) {
      onError('')
    }

    setTimeout(() => {
      FormHelpers.toggleButtonState({
        isLoading: false,
        buttons,
        showSpinner,
      })
    }, 150)
  },
}
